var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateRangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8861 0H2.11391C0.946431 0 0 0.989451 0 2.21V12.79C0 14.0106 0.946431 15 2.11391 15H19.8861C21.0536 15 22 14.0106 22 12.79V2.21C22 0.989451 21.0536 0 19.8861 0Z",
    transform: "translate(1 6)",
    stroke: "#1E334E",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H0V2H2V0Z",
    transform: "translate(5.25 10)",
    fill: "#F7931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H0V2H2V0Z",
    transform: "translate(17.75 10)",
    fill: "#F7931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H0V2H2V0Z",
    transform: "translate(13.5801 10)",
    fill: "#F7931E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89 0H0.11C0.0492483 0 0 0.0492488 0 0.11V1.89C0 1.95075 0.0492483 2 0.11 2H1.89C1.95075 2 2 1.95075 2 1.89V0.11C2 0.0492488 1.95075 0 1.89 0Z",
    transform: "translate(9.41992 10)",
    fill: "#F7931E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0H0V2H2V0Z",
    transform: "translate(5.25 15)",
    fill: "#F7931E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89 0H0.11C0.0492483 0 0 0.0492483 0 0.11V1.89C0 1.95075 0.0492483 2 0.11 2H1.89C1.95075 2 2 1.95075 2 1.89V0.11C2 0.0492483 1.95075 0 1.89 0Z",
    transform: "translate(9.41992 15)",
    fill: "#F7931E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H0V2H1V0Z",
    transform: "translate(6 4)",
    fill: "#1E334E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1 0H0V2H1V0Z",
    transform: "translate(17.5 4)",
    fill: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateRangeIcon);
export default __webpack_public_path__ + "static/media/DateRange_Icon.d11acb8ca81f929fb12b49b51fccd86e.svg";
export { ForwardRef as ReactComponent };